<template>
  <div style="height:100%;">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-tabs v-model="activeName">
          <el-tab-pane label="设备状态统计" name="first">
            <Chart target="Chart" ChartId="b" chartType="pie" v-if="'first' === activeName"></Chart>
          </el-tab-pane>
          <el-tab-pane label="各区县范围内设备数" name="second">
            <Chart target="Chart" ChartId="a" chartType="histogram" v-if="'second' === activeName"></Chart>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="12">
        <el-tabs v-model="activeName2">
          <el-tab-pane label="所有电台频率数量" name="first">
            <Chart target="Chart" ChartId="c" chartType="line" v-if="'first' === activeName2"></Chart>
          </el-tab-pane>
          <el-tab-pane label="非法电台数量" name="second">
            <Chart target="Chart" ChartId="c1" chartType="line_b" v-if="'second' === activeName2"></Chart>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-tabs v-model="activeName3">
          <el-tab-pane label="扫描到非法电台频率的设备统计" name="first">
            <Chart target="Chart" ChartId="c" chartType="pie_b" v-if="'first' === activeName3"></Chart>
          </el-tab-pane>
          <el-tab-pane label="非法电台频率被扫描到的次数统计" name="second">
            <Chart target="Chart" ChartId="c1" chartType="pie_c" v-if="'second' === activeName3"></Chart>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="12">
        <el-tabs v-model="activeName4">
          <el-tab-pane label="本周任务执行数量统计" name="first">
            <Chart target="Chart" ChartId="e" chartType="pie_d" v-if="'first' === activeName4"></Chart>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Chart from "@/components/Charts/Chart_.vue";
  export default {
    components: {
      Chart
    },
    methods: {

    },
    data() {
      return {
        activeName: 'first',
        activeName2: 'first',
        activeName3: "first",
        activeName4: "first"
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };

</script>
<style scoped>
  .el-row {
    height: 50%;
  }

  .el-col,
  .el-tabs,
  .el-tab-pane {
    height: 100%;
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Chart.vue